<template>
  <div v-if="group">
    <div class="p-4 overflow-auto max-h-[40vh] bg-charcoal-100 dark:bg-dark-950 space-y-4">
      <div>
        <p class="font-bold text-xl"> {{ $t('components.Event.group.title', { name: group.name }) }}</p>
        <p class="mt-1">{{ $t('components.Event.group.content') }}</p>
      </div>
      
      <div class="bg-white dark:bg-dark-800 dark:text-dark-50 rounded-xl shadow p-4">
        <TextHider :max-height="46" gradient-color="" v-slot="{ modelValue }"> 
          <div class="text-body leading-relaxed" v-html="modelValue ? nl2br(group.description) : stripTags(group.description)" />
        </TextHider>
      </div>
    </div>

    <div class="bg-white border-t border-charcoal-200 dark:bg-dark-800 dark:border-dark-600 flex items-center space-x-2 p-2.5">
      <ButtonBase style-type="round" class="shrink-0" color="white" @click="() => emit('previous')">
        <IconBase name="cute/angle-right" class="rotate-180" :width="20" />
      </ButtonBase>

      <ButtonBase
        color="xweak"
        is-full
        class="pointer-events-none"
        v-if="group && group.isPending(currentUser?._id)"
      >
        {{ $t('components.Event.group.pending') }}
      </ButtonBase>
      <ButtonBase
        color="builders"
        is-full
        :to="{ name: 'app-groups-slug', params: { slug: group.slug } }"
        v-else
      >
        {{ $t('actions.joinGroup') }}
      </ButtonBase>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Event, Group } from '@/classes'
import UserStore from '@/store/user'

const props = defineProps<{
  event: Event
  group: Group | null
}>()

const { event, group } = toRefs(props)

const userStore = UserStore()
const { currentUser } = storeToRefs(userStore)

const route = useRoute()
const router = useRouter()

const emit = defineEmits<{
  (e: 'next'): void
  (e: 'previous'): void
}>()

watch(() => group.value?.isMember(currentUser.value?._id), (v) => {
  if (!group.value) return

  if (v) emit('next')
})
</script>